import { logMemberClick, logMemberPageView } from './memberActivity';

// Google Analytics utility functions

// Initialize Google Analytics
// Note: GA script is loaded directly in index.html for production
// This function is kept for backwards compatibility but won't do anything
// if gtag is already loaded from the HTML
export const initGA = (trackingId) => {
  if (!trackingId || typeof window === 'undefined') {
    return;
  }

  // If gtag is already loaded (from HTML), just ensure dataLayer exists
  if (window.gtag) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    return;
  }

  // Fallback: Create script element if not already loaded
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script1);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', trackingId, {
    page_path: window.location.pathname,
  });
};

// Track page view
export const trackPageView = (path) => {
  logMemberPageView(path);

  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  // Use the tracking ID from the config (hardcoded in HTML) or fallback to env var
  const trackingId = 'G-11NXKFFSRD' || process.env.REACT_APP_GA_TRACKING_ID;

  window.gtag('config', trackingId, {
    page_path: path,
  });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  logMemberClick(action, category, label);

  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
